const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var FlagAr16 = function FlagAr16(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.882 2h12.236C15.158 2 16 2.843 16 3.882v7.53c0 1.04-.843 1.882-1.882 1.882H1.882A1.882 1.882 0 0 1 0 11.412v-7.53C0 2.842.843 2 1.882 2zm0 .47c-.78 0-1.411.633-1.411 1.412v7.53c0 .78.632 1.411 1.411 1.411h12.236a1.41 1.41 0 0 0 1.411-1.411v-7.53a1.41 1.41 0 0 0-1.411-1.411H1.882z",
      fill: "#D8DDE1",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M14.1 2.5H1.9A1.4 1.4 0 0 0 .5 3.9v7.55a1.4 1.4 0 0 0 1.4 1.4h12.2a1.4 1.4 0 0 0 1.4-1.4V3.9a1.4 1.4 0 0 0-1.4-1.4z",
      fill: "#74ACDF",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M15.5 6H.5v3.45h15V6z",
      fill: "#fff",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M7.98 6.473c.002-.024.038-.024.04 0l.047.59c.002.022.032.026.039.006l.199-.558c.008-.023.043-.014.038.01l-.107.583c-.004.02.024.032.036.015l.336-.488c.014-.02.046-.002.035.02l-.254.535c-.01.02.014.038.03.024l.452-.384c.019-.016.044.01.028.028l-.384.451c-.014.016.004.04.024.031l.535-.254c.022-.01.04.02.02.034l-.488.337c-.018.012-.006.04.015.036l.583-.107c.024-.005.033.03.01.038l-.558.199c-.02.007-.016.037.005.039l.59.047c.025.002.025.038 0 .04l-.59.047c-.021.002-.025.032-.005.039l.558.199c.023.008.014.043-.01.038l-.583-.107c-.021-.004-.033.024-.015.036l.488.336c.02.014.002.046-.02.035l-.535-.254c-.02-.01-.038.014-.024.03l.384.452c.016.019-.01.044-.028.028L8.42 8.24a.02.02 0 0 0-.031.024l.254.535c.01.022-.02.04-.035.02l-.336-.488c-.012-.018-.04-.006-.036.015l.107.583c.005.024-.03.033-.038.01l-.199-.558c-.007-.02-.037-.016-.039.005l-.047.59c-.002.025-.038.025-.04 0l-.047-.59c-.002-.021-.032-.025-.04-.005l-.198.558c-.008.023-.043.014-.038-.01l.107-.583c.004-.021-.024-.033-.036-.015l-.337.488c-.014.02-.045.002-.034-.02l.254-.535c.01-.02-.015-.038-.03-.024l-.452.384c-.019.016-.044-.01-.028-.028l.384-.451a.02.02 0 0 0-.024-.031l-.535.254c-.022.01-.04-.02-.02-.035l.488-.336c.017-.012.006-.04-.015-.036l-.583.107c-.024.005-.033-.03-.01-.038l.558-.199c.02-.007.016-.037-.005-.039l-.59-.047c-.025-.002-.025-.038 0-.04l.59-.047c.021-.002.025-.032.005-.04l-.558-.198c-.023-.008-.014-.043.01-.038l.583.107c.021.004.032-.024.015-.036l-.488-.337c-.02-.014-.002-.045.02-.034l.535.254c.02.01.038-.015.024-.031L7.1 6.854c-.016-.019.01-.044.028-.028l.451.384c.016.014.04-.005.031-.024l-.254-.535c-.01-.022.02-.04.034-.02l.337.488c.012.017.04.006.036-.015l-.107-.583c-.005-.024.03-.033.038-.01l.199.558c.007.02.037.016.039-.005l.047-.59z",
      fill: "#F6B40E",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m8 6.6-.037.466c-.005.054-.08.064-.097.013l-.157-.44.084.46c.01.052-.06.081-.09.037l-.266-.385.201.422c.023.049-.036.095-.077.06l-.357-.304.304.357c.035.04-.011.1-.06.077l-.422-.2.385.265c.044.03.015.1-.038.09l-.46-.084.441.157c.05.018.04.092-.013.097l-.466.037.466.037c.054.005.064.08.013.097l-.44.157.46-.084c.052-.01.081.06.037.09l-.385.265.422-.2c.049-.023.095.036.06.077l-.304.356.357-.303c.04-.035.1.011.077.06l-.2.422.265-.385c.03-.044.1-.015.09.038l-.084.46.157-.441c.018-.05.092-.041.097.013L8 8.85l.037-.466c.005-.054.08-.064.097-.013l.157.44-.084-.46c-.01-.052.06-.081.09-.037l.265.385-.2-.422c-.023-.049.036-.095.077-.06l.356.303-.303-.356c-.035-.04.011-.1.06-.077l.422.2-.385-.265c-.044-.03-.015-.1.038-.09l.46.084-.441-.157c-.05-.018-.041-.092.013-.097l.466-.037-.466-.037c-.054-.005-.064-.08-.013-.097l.44-.157-.46.084c-.052.01-.081-.06-.037-.09l.385-.266-.422.201c-.049.023-.095-.036-.06-.077l.303-.357-.356.304c-.04.035-.1-.011-.077-.06l.2-.422-.265.385c-.03.044-.1.015-.09-.038l.084-.46-.157.44c-.018.052-.092.042-.097-.012L8 6.6zm.02-.127c-.002-.024-.038-.024-.04 0l-.047.59c-.002.022-.032.026-.04.006l-.198-.558c-.008-.023-.043-.014-.038.01l.107.583c.004.02-.024.032-.036.015L7.39 6.63c-.014-.02-.045-.002-.034.02l.254.535c.01.02-.015.038-.03.024l-.452-.384c-.019-.016-.044.01-.028.028l.384.451c.014.016-.004.04-.024.031l-.535-.254c-.022-.01-.04.02-.02.034l.488.337c.017.012.006.04-.015.036l-.583-.107c-.024-.005-.033.03-.01.038l.558.199c.02.007.016.037-.005.039l-.59.047c-.025.002-.025.038 0 .04l.59.047c.021.002.025.032.005.039l-.558.199c-.023.008-.014.043.01.038l.583-.107c.021-.004.032.024.015.036l-.488.336c-.02.014-.002.046.02.035l.535-.254c.02-.01.038.014.024.03l-.384.452c-.016.019.01.044.028.028l.451-.384c.016-.014.04.004.031.024l-.254.535c-.01.022.02.04.034.02l.337-.488c.012-.018.04-.006.036.015l-.107.583c-.005.024.03.033.038.01l.199-.558c.007-.02.037-.016.039.005l.047.59c.002.025.038.025.04 0l.047-.59c.002-.021.032-.025.039-.005l.199.558c.008.023.043.014.038-.01l-.107-.583c-.004-.021.024-.033.036-.015l.336.488c.014.02.046.002.035-.02l-.254-.535c-.01-.02.014-.038.03-.024l.452.384c.019.016.044-.01.028-.028l-.384-.451a.02.02 0 0 1 .024-.031l.535.254c.022.01.04-.02.02-.035l-.488-.336c-.018-.012-.006-.04.015-.036l.583.107c.024.005.033-.03.01-.038l-.558-.199c-.02-.007-.016-.037.005-.039l.59-.047c.025-.002.025-.038 0-.04l-.59-.047c-.021-.002-.025-.032-.005-.04l.558-.198c.023-.008.014-.043-.01-.038l-.583.107c-.021.004-.033-.024-.015-.036l.488-.337c.02-.014.002-.045-.02-.034l-.535.254c-.02.01-.038-.015-.024-.031l.384-.451c.016-.019-.01-.044-.028-.028l-.451.384c-.017.014-.04-.005-.031-.024l.254-.535c.01-.022-.02-.04-.035-.02l-.336.488c-.012.017-.04.006-.036-.015l.107-.583c.005-.024-.03-.033-.038-.01l-.199.558c-.007.02-.037.016-.039-.005l-.047-.59z",
      fill: "#85340A",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "m8.002 6.923.04.498.168-.47-.09.49.284-.41-.215.45.38-.323-.323.38.451-.214-.411.284.491-.09-.47.167.498.04-.499.04.471.168-.491-.09.411.283-.451-.215.324.381-.381-.324.215.452-.284-.412.09.492-.168-.471-.04.498-.04-.498-.167.47.09-.491-.284.412.215-.452-.38.324.323-.38-.451.214.411-.284-.491.09.47-.167-.498-.04.499-.04-.471-.168.491.09-.411-.283.451.214-.324-.38.381.324-.215-.452.284.412-.09-.492.168.471.04-.498z",
      fill: "#85340A",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M8.625 7.725a.625.625 0 1 1-1.25 0 .625.625 0 0 1 1.25 0z",
      fill: "#F6B40E",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 8.32a.595.595 0 1 0 0-1.19.595.595 0 0 0 0 1.19zm0 .03A.625.625 0 1 0 8 7.1a.625.625 0 0 0 0 1.25z",
      fill: "#85340A",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M8.19 7.541a.11.11 0 0 0-.096.05c.043.04.137.043.201-.004a.147.147 0 0 0-.106-.046zm-.001.009c.037 0 .071.016.076.033-.043.047-.111.043-.154.009a.09.09 0 0 1 .078-.042z",
      fill: "#843511",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M7.915 7.737a.039.039 0 1 0 .039.06.081.081 0 0 0 .046.012h.005a.081.081 0 0 0 .046-.012c.007.01.019.016.032.016a.038.038 0 0 0 .007-.076c.01.003.017.013.017.024a.026.026 0 0 1-.051.001.064.064 0 0 1-.053.035.064.064 0 0 1-.054-.035.026.026 0 0 1-.051-.001c0-.01.007-.02.017-.024zm.042.113c-.043 0-.06.04-.098.065.021-.009.038-.025.068-.043.03-.017.055.004.072.004.018 0 .043-.02.073-.004.03.018.048.034.07.043-.04-.026-.057-.064-.1-.064A.115.115 0 0 0 8 7.864a.114.114 0 0 0-.043-.013z",
      fill: "#85340A",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M7.942 7.901a.294.294 0 0 0-.07.014c.076-.017.093.009.127.009.035 0 .052-.026.129-.01-.086-.025-.103-.008-.128-.008-.017 0-.03-.006-.058-.005z",
      fill: "#85340A",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "m7.875 7.914-.016.001c.09.009.046.06.14.06H8c.094 0 .052-.051.141-.06-.094-.008-.064.047-.141.047-.073 0-.05-.048-.125-.048z",
      fill: "#85340A",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M8.077 8.053a.077.077 0 0 0-.154 0 .08.08 0 0 1 .154 0zm-.422-.513c.098-.085.222-.098.29-.034a.167.167 0 0 1 .032.072c.009.048-.006.1-.045.155.005 0 .013.004.018.008a.304.304 0 0 0 .034-.195.276.276 0 0 0-.013-.048c-.094-.077-.222-.086-.316.042z",
      fill: "#85340A",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M7.808 7.515c.056 0 .069.013.094.034.026.021.039.017.043.021.004.005 0 .017-.008.013a.241.241 0 0 1-.052-.034c-.025-.021-.05-.021-.077-.021-.076 0-.12.064-.128.06-.008-.005.043-.073.128-.073z",
      fill: "#85340A",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M7.81 7.621a.038.038 0 1 0 0-.076.038.038 0 0 0 0 .076z",
      fill: "#85340A",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M7.706 7.609c.072.055.145.051.188.025.043-.025.043-.034.034-.034-.009 0-.017.009-.051.026-.034.017-.086.017-.171-.017z",
      fill: "#85340A",
    })
  );
};
FlagAr16.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
const sizeMap = {
  16: FlagAr16,
};
export function FlagAr(_ref) {
  let { size = "16" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["16"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'FlagAr' icon. Please use one of the available sizes: '16'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
